const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export { CHANGE_LANGUAGE }